"use client";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { ErrorBoundary } from "react-error-boundary";



// if (process.env.NODE_ENV === 'production') {
//   // List of console methods to override
//   const methods = ['log', 'warn', 'error', 'info', 'debug', 'trace'];

//   // Override each method with an empty function
//   methods.forEach((method) => {
//     console[method] = () => {};
//   });
// }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App></App>
    </ErrorBoundary>


  </React.StrictMode>
);

